module.exports = __webpack_public_path__ + "6b4b4c876e708e51bb9c89f17d29c8a7.pdf";